import { Activity, currentRequestTimeStamp } from "../../Constants";
import { buildDiscoverNowLane, buildTransporterEntry } from "./spotLaneFormatter";

/**
 * Builds the list of lane objects from DiscoverNow rspl data.
 *
 * Extracted from NewEnquiry.getDatafromdiscovernow().
 * Caller is responsible for calling setsend_data() and settransporterlistempty().
 *
 * @param {Array} rspl - Route/spot list passed in from DiscoverNow.
 * @param {Array} tenure - The currently selected tenure option array.
 * @returns {{ lanes: Array, hasEmptyTransporters: boolean }}
 */
export const buildDiscoverNowLanes = (rspl, tenure) => {
  const lanes = [];
  let hasEmptyTransporters = false;

  if (!rspl || rspl.length === 0) {
    return { lanes, hasEmptyTransporters };
  }

  Activity([
    {
      screen: "LoRRI Spot",
      module: "New enquiry",
      user_activity: "New Enquiry screen visited",
      timestamp: currentRequestTimeStamp(),
    },
  ]);

  rspl.forEach((r) => {
    let brlist = [];
    if (r.transporter_list && r.transporter_list.length > 0) {
      brlist = r.transporter_list.map((br) =>
        buildTransporterEntry(br, false),
      );
    } else {
      hasEmptyTransporters = true;
    }
    lanes.push(buildDiscoverNowLane(r, tenure, brlist));
  });

  return { lanes, hasEmptyTransporters };
};
